import Router from '@/router/index'
import axios from 'axios'
import { Message, Loading } from 'element-ui'
import merge from 'webpack-merge'
var moment = require('moment');
// 请求超时时间
axios.defaults.timeout = 50000;
let loading; 
let axiosNum = 0;  //限制多个请求出现多个loading
let msgNum = 0;    //限制多个错误提示出现
let requestId = new Date().getTime();
const CancelToken = axios.CancelToken;
const source = CancelToken.source();

function sleep(delay) {  //延迟函数
    let start = (new Date()).getTime();
    while((new Date()).getTime() - start < delay) {
        continue;
    }
}

axios.interceptors.request.use(
    config => {
        if(config.url != 'login/getUserInfo'){
            config.cancelToken = source.token; // 全局添加cancelToken
        }
        return config;
    },
    err => {
        return Promise.reject(err);
    }
);
/** 设置响应拦截 **/
axios.interceptors.response.use(
    response => {
        axiosNum--;
        if(loading && !axiosNum){
            loading.close();
            loading = '';
        }
        if(response.config.responseType == 'blob'){   //下载文件
            const reader = new FileReader();
            reader.readAsText(response.data);
            reader.onload = e => {
                if(e.currentTarget.result.search('code') != -1) {  //文件下载请求失败
                    const res = JSON.parse(e.currentTarget.result);
                    responseCheck(res)
                }else{
                    let blob = new Blob([response.data]);
                    let downloadA = document.createElement('a');
                    switch(response.config.url) {
                        case 'work/downloadFile': downloadA.download = '导入工单模板.xlsx'; break;
                        case 'over_view/timeInfoExport': downloadA.download = '处理耗时统计.xlsx'; break;
                        case 'work/exportWorkInfo': downloadA.download = `工单导出报表_${moment(parseInt(new Date().getTime())).format('YYYY-MM-DD')}.xlsx`; break;
                        case 'sale/saleStatisticsExport': downloadA.download = `销售统计报表_${moment(parseInt(new Date().getTime())).format('YYYY-MM-DD')}.xlsx`; break;
                        case 'sale/saleDetailExport': downloadA.download = `销售统计明细表_${moment(parseInt(new Date().getTime())).format('YYYY-MM-DD')}.xlsx`; break;
                        case 'sale/orderDetailExport': downloadA.download = `销售订单明细表_${JSON.parse(response.config.data).name}_${moment(parseInt(new Date().getTime())).format('YYYY-MM-DD')}.xlsx`; break;
                        case 'product/sn-template': downloadA.download = `导入sn号模板.xlsx`; break;
                        case 'tool/sn_export': downloadA.download = `导出sn号数据_${moment(parseInt(new Date().getTime())).format('YYYY-MM-DD')}.xlsx`; break;
                        case 'tool/sn_export_m1': downloadA.download = `导出sn号数据_${moment(parseInt(new Date().getTime())).format('YYYY-MM-DD')}.xlsx`; break;
                        case 'tool/logs/m1/export': downloadA.download = `导出M1日志数据_${moment(parseInt(new Date().getTime())).format('YYYY-MM-DD')}.xlsx`; break;
                        case 'mao/redeem/export': downloadA.download = `导出订单列表_${moment(parseInt(new Date().getTime())).format('YYYY-MM-DD')}.xlsx`; break;
                        case 'loyalty/op/export': downloadA.download = `vip-loyalty审核明细_${moment(parseInt(new Date().getTime())).format('YYYY-MM-DD')}.xlsx`; break;
                        case 'app_view/multiBindUserExport': downloadA.download = `多设备绑定用户_${moment(parseInt(new Date().getTime())).format('YYYY-MM-DD')}.xlsx`; break;
                    }
                    let href = window.URL.createObjectURL(blob);
                    downloadA.href = href;
                    document.body.appendChild(downloadA);
                    downloadA.click();
                    document.body.removeChild(downloadA);
                    window.URL.revokeObjectURL(href);
                    return response;
                }
            }
            
        }
        if(response.data.code){
            responseCheck(response.data, response.config.url);
        }
        return response;
    },
    error => {
        axiosNum--;
        if(loading && !axiosNum){
            loading.close();
            loading = '';
        }
        if (axios.isCancel(error)) { // 取消请求的情况下，终端Promise调用链
            return new Promise(() => {});
        } else {
            return Promise.reject(error);
        }
    }
);

function responseCheck(res, url) {
    switch (res.code) {
        case 10003:
            Message.error('用户暂无访问权限!'); 
            source.cancel(); // 取消其他正在进行的请求
            Router.push({name: 'welcome'});
            Router.go(0);
            break;
        case 10001: 
        case 10002:
        case 10009:
            if(!window.h5sdk) {
                Message.error('登录状态失效，请重新登录!');
            }
            source.cancel();
            localStorage.setItem('token', '');
            Router.push({name: 'login'});
            Router.go(0);
            break;
        case 1012:  //没有操作权限
            Message.error('用户暂无此权限!'); 
            if(url == 'iotuser/userByAccount') break;
            res.data.allow_rule_keys.forEach(item => {
                let key = item.split('-')[item.split('-').length - 1];
                if(key == '101') {  //没有页面查看权限
                    source.cancel(); // 取消其他正在进行的请求
                    setTimeout(() => {
                        Router.push({name: 'home'});
                        Router.go(0);
                    }, 2000)
                    return;
                }
            })
            break;
        case 10004:
        case 10010:  //用户被冻结，账号不存在，没有任何页面权限
            Router.push({name: 'error', query: {code: res.code}});
            source.cancel();
            break;
        case 200: 
        case 0:
            break;
        default:
            Message.error(res.msg || res.message || '操作失败，请稍后重试!');
    }
}

const ajax = function (url,params,type,responseType, isloading) {
    let setData,setParams;
    if(type == 'put' || type == 'post' || type == 'patch'){
        setData = params;
    }else{
        setParams = params;
    }
    axiosNum++;
    return new Promise((resolve, reject) => {
        let background = 'rgba(0, 0, 0, 0.7)';
        if(url == 'login/refreshToken'){
            background = 'rgba(0, 0, 0, 0)';
        }
        if(!isloading && !loading && url != 'login/refreshToken'){
            loading = Loading.service({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: background
            })
        }
        axios({
            baseURL: process.env.BASE_API,
            url: url, 
            method: type,
            params: setParams,
            data: setData,
            responseType: responseType || 'json',
            headers: {
                    'Authorization': 'Bearer ' + (localStorage.getItem('token')),
                    'Region': Router.history.current.query.region || '',
                    'Cache-Control': 'no-cache',
                    'Request-Id': requestId++,
                   // 'X-Dev-UnionId':'on_072a3cee82379825ed660d60ebad7b0c'
                    }
        })
        .then(function(data){
            if(!data.data || data.data.code == 200 || data.data.code == 0 || data.data.code == 50001){
                resolve(data.data);
            }
        })
        .catch(function(data){
            msgNum++;
            if(url == 'login/getToken') {
                Router.push({query: merge({code: ''})});
                // Router.go(0)
            }
            if(loading && !axiosNum){
                loading.close();
                loading = '';
            }
            if(msgNum == 1) {
                Message.error('网络链接错误，请联系管理员！');
            }
            setTimeout(function() {
                msgNum--;
            }, 1000)
        })
    })
    
};

export default ajax;


// WEBPACK FOOTER //
// ./src/axios/http.js